import { render, staticRenderFns } from "./string-wysiwyg.vue?vue&type=template&id=adda9426"
import script from "./string-wysiwyg.vue?vue&type=script&lang=js"
export * from "./string-wysiwyg.vue?vue&type=script&lang=js"
import style0 from "./string-wysiwyg.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/content/string/string-wysiwyg.vue
// module id = +hoZ
// module chunks = 0